import CommissionSVG from "@assets/svg/Commission1";
import NotFound from "@assets/svg/NotFound";
import FlatList from "@components/FlatList";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import t from "@constants/localization";
import { colors } from "@constants/theme";
import analytics from "@services/analytics";
import { normalize } from "@utils/metrics_1";
import React from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { connect } from "react-redux";

const PATH = "screens/ShopPerformance/Components/Card";
const PATH1 = "screens/ShopPerformance/TabView";

const countInfo = [
  t(`${PATH}/orders`),
  t(`${PATH}/customers`),
  t(`${PATH}/quantity`),
];

function RenderProduct({
  productDetails,
  currMonth,
  selectedMonth,
  setSaleCard,
  setCommissionCard,
  navigation,
}) {
  const sendCxClicks = (
    productType,
    subCategoryName,
    primaryCategoryId,
    subCategoryId,
    productTypeId,
    superCategoryName,
  ) => {
    setSaleCard(false);
    setCommissionCard(false);
    navigation.navigate("CategoryNavigation", {
      fromSalesReport: true,
      selectedCat: primaryCategoryId,
      selectedSubCat: subCategoryId,
      pTypeId: productTypeId,
    });

    analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.PTYPE_CAT_CLICKED, {
      screen: "Shop_performance",
      Cat: superCategoryName,
      subCat: subCategoryName,
      ptype: productType,
    });
  };

  const rowRenderer = ({ item }) => {
    const {
      commissions,
      noOfCustomers,
      productTypeId,
      productType,
      sales,
      subCategoryId,
      subCategoryName,
      primaryCategoryId,
      superCategoryName,
    } = item;

    return (
      <TouchableOpacity
        style={styles.container}
        onPress={() =>
          sendCxClicks(
            productType,
            subCategoryName,
            primaryCategoryId,
            subCategoryId,
            productTypeId,
            superCategoryName,
          )
        }
      >
        <View style={styles.tabContainer}>
          <View style={styles.left}>
            <View style={styles.nameContainer}>
              <Text
                numberOfLines={1}
                lineBreakMode="ellepises"
                style={[styles.name, { marginRight: 6 }]}
              >
                {productType}
              </Text>
            </View>

            <View style={{ flexDirection: "row", marginTop: 0 }}>
              <Text style={styles.noOfOrder}>{noOfCustomers}</Text>
              <Text style={styles.countInfo}>{countInfo[1]}</Text>
            </View>
          </View>
          <View style={styles.right}>
            <View style={styles.amt}>
              <Text
                style={[
                  styles.amount,
                  {
                    fontFamily: "NotoSansDevanagari-Regular",
                  },
                ]}
              >
                ₹
              </Text>
              <Text style={styles.amount}>
                {Number(sales) > 0 ? Number(sales).toFixed(1) : 0}
              </Text>
            </View>

            <View style={styles.commission}>
              <View style={styles.comm}>
                <CommissionSVG />
              </View>
              <View
                style={{
                  flexDirection: "row",
                }}
              >
                <Text
                  style={[
                    styles.commissionAmount,
                    { fontFamily: "NotoSansDevanagari-Regular" },
                  ]}
                >
                  ₹
                </Text>
                <Text style={styles.commissionAmount}>
                  {Number(commissions) > 0 ? Number(commissions).toFixed(1) : 0}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ flex: 1 }}>
      {productDetails.length > 0 ? (
        <FlatList
          data={productDetails}
          renderItem={rowRenderer}
          keyExtractor={(item, index) => index.toString()}
          initialNumToRender={25}
          windowSize={50}
        />
      ) : (
        <View style={styles.NotFountView}>
          <View style={{ alignSelf: "center" }}>
            <NotFound />
          </View>
          <Text style={styles.NotFoundText}>
            {currMonth === selectedMonth
              ? t(`${PATH1}/NotSoldAnyProduct`)
              : t(`${PATH1}/NotSoldAnyProductInPrevMonth`)}
          </Text>
        </View>
      )}
    </View>
  );
}

function mapStateToProps({
  shopPerformance: { productDetails, currMonth, selectedMonth },
}) {
  return {
    productDetails,
    currMonth,
    selectedMonth,
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    shadowColor: colors.lightGrayWhite,
    paddingVertical: 12,
    marginBottom: 1,
    paddingHorizontal: 16,
    ...Platform.select({
      android: {
        elevation: 8,
      },
      default: {
        // for ios and other screens
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 8,
      },
    }),
  },
  left: {
    flex: 1,
  },
  tabContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  nameContainer: {
    flexDirection: "row",
    paddingBottom: 2,
    alignItems: "center",
  },
  name: {
    color: colors.black,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "NotoSansDevanagari-Medium",
  },
  amount: {
    color: colors.black,
    fontSize: 18,
    lineHeight: 26,
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  right: {
    marginLeft: 10,
    alignSelf: "center",
  },
  amt: {
    flexDirection: "row",
    alignItems: "flex-end",
    alignSelf: "center",
  },
  commission: {
    flexDirection: "row",
    alignSelf: "center",
  },
  commissionAmount: {
    fontSize: 14,
    lineHeight: 21,
    color: "#00AB59",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  noOfOrder: {
    color: "rgba(0, 0, 0, 0.56)",
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
    lineHeight: 18,
  },
  comm: { marginRight: 0 },
  countInfo: {
    marginLeft: 5,
    fontSize: 12,
    lineHeight: 18,
    color: "rgba(0, 0, 0, 0.56)",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  NotFountView: { flex: 1, justifyContent: "center" },
  NotFoundText: {
    marginTop: normalize(16),
    fontSize: normalize(16),
    lineHeight: normalize(26),
    fontFamily: "NotoSansDevanagari-SemiBold",
    textAlign: "center",
  },
});

export default connect(mapStateToProps)(RenderProduct);
